import { render, staticRenderFns } from "./Economics.vue?vue&type=template&id=1e312128&scoped=true"
import script from "./Economics.vue?vue&type=script&lang=js"
export * from "./Economics.vue?vue&type=script&lang=js"
import style0 from "./Economics.vue?vue&type=style&index=0&id=1e312128&prod&lang=css"
import style1 from "./Economics.vue?vue&type=style&index=1&id=1e312128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e312128",
  null
  
)

export default component.exports